import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./app/App.tsx";
import "crypto-js"; // Ensure crypto-js is imported
import "./index.css";

// Import necessary polyfills
import { Buffer } from "buffer";
import process from "process";

if (typeof global === "undefined") {
  (window as Window & typeof globalThis).global = window;
}

global.Buffer = Buffer;
global.process = process;

createRoot(document.getElementById("root")!).render(<App />);
